import logo from "./assets/logo.png";

export default function Logo({ size = 70 }) {
  return (
    <img
      src={logo}
      alt="Logo"
      style={{
        width: size,
        height: size,
        objectFit: "contain"
      }}
    />
  );
}